import { Routes } from '@angular/router';
import { adminGuard } from './guards/admin-guard';
import { authGuard } from './guards/auth-guard';
import { guestGuard } from './guards/guest-guard';
import { unsavedDiagramGuard } from './guards/unsaved-diagram.guard';

export const routes: Routes = [
  { path: 'login', loadComponent: () => import('./pages/login/login.page').then((m) => m.LoginPage), canActivate: [guestGuard] },
  {
    path: 'register',
    loadComponent: () => import('./pages/register/register.page').then((m) => m.RegisterPage),
    canActivate: [guestGuard],
  },
  {
    path: 'reset-password',
    loadComponent: () => import('./pages/reset-password/reset-password.page').then((m) => m.ResetPasswordPage),
  },
  {
    path: 'shared/:token',
    loadComponent: () => import('./pages/shared-diagram/shared-diagram.page').then((m) => m.SharedDiagramPage),
  },
  {
    path: '',
    canActivate: [authGuard],
    loadComponent: () => import('./layout/main-layout').then((m) => m.MainLayout),
    children: [
      { path: '', pathMatch: 'full', redirectTo: 'projects' },
      { path: 'projects', loadComponent: () => import('./pages/projects/projects.page').then((m) => m.ProjectsPage) },
      { path: 'archive', loadComponent: () => import('./pages/archive/archive.page').then((m) => m.ArchivePage) },
      {
        path: 'archive/project/:projectId',
        loadComponent: () => import('./pages/project-detail/project-detail.page').then((m) => m.ProjectDetailPage),
        children: [
          {
            path: 'folder/:folderId',
            loadComponent: () =>
              import('./pages/project-detail/project-detail.page').then((m) => m.ProjectFolderRoute),
          },
        ],
      },
      {
        path: 'members',
        canActivate: [adminGuard],
        loadComponent: () => import('./pages/members/members.page').then((m) => m.MembersPage),
      },
      {
        path: 'knowledge',
        loadComponent: () => import('./pages/knowledge/knowledge.page').then((m) => m.KnowledgePage),
      },
      {
        path: 'projects/:projectId',
        loadComponent: () => import('./pages/project-detail/project-detail.page').then((m) => m.ProjectDetailPage),
        children: [
          {
            path: 'folder/:folderId',
            loadComponent: () =>
              import('./pages/project-detail/project-detail.page').then((m) => m.ProjectFolderRoute),
          },
        ],
      },
      {
        path: 'projects/:projectId/diagrams/:diagramId/edit',
        loadComponent: () => import('./pages/diagram-editor/diagram-editor.page').then((m) => m.DiagramEditorPage),
        canDeactivate: [unsavedDiagramGuard],
      },
      {
        path: 'projects/:projectId/diagrams/:diagramId/view',
        loadComponent: () => import('./pages/diagram-viewer/diagram-viewer.page').then((m) => m.DiagramViewerPage),
      },
    ],
  },
  { path: '**', redirectTo: 'projects' },
];
